import styled from '@emotion/styled';
import { createElement, FC } from 'react';

import { PeriodicImprovementPerformanceWithAllFieldsFragment } from '../../../../generated/graphql';
import { SPACING_LARGE, SPACING_UNIT } from '../../../constant/spacing';
import PublicId from '../../primitive/PublicId';
import ImprovementRateBarChart from './ImprovementRateBarChart';

type Props = {
  periodicImprovementPerformance: PeriodicImprovementPerformanceWithAllFieldsFragment;
  className?: string;
};

const ImprovementRateBarChartList: FC<Props> = ({ periodicImprovementPerformance, className }) => {
  return (
    <Root className={className}>
      {periodicImprovementPerformance.creatives.map((creative) => (
        <Wrapper key={creative.creativeId}>
          <SubHeading>
            {creative.creation && <PublicId id={creative.creation.id} variant="inherit" color="textSecondary" />}
          </SubHeading>
          <ImprovementRateBarChart periodicImprovementValues={creative.values} />
        </Wrapper>
      ))}
    </Root>
  );
};

const Root = styled('div')({});

const SubHeading = styled('div')({
  marginBottom: SPACING_UNIT,
});

const Wrapper = styled('div')({
  marginBottom: SPACING_LARGE,
});

export default ImprovementRateBarChartList;
